resourcePaths = '{"rootPath":"","assetsPath":""}';function _ComponentDataBind() {
  // requires this.super(); in init and destroy of extending component.
  var components = mogo.repository();
  var portalObj = null;
  for (var key in components) {
    if (components[key].declaredClass === "Portal" || components[key].declaredClass === "Marketing") {
      portalObj = components[key];
    }
  }
  this._presenterAvalible = portalObj !== null;

  if (this._presenterAvalible) {
    this.presenter = portalObj.presenter;
    this._boundData = {};
  }

  this.init = function() {
    if (!this._presenterAvalible) return false;

    // loop through html data attributes.
    // create bindings for data bound strings
    for (var key in this.node.dataset) {
      if (this.node.dataset.hasOwnProperty(key) && key.indexOf('bind') > -1 && key.length > 4) {
        // Check if computed or model data.
        if (this.node.dataset[key].indexOf('.') < 0) {
          this._extendComputedDataBind(key, this.node.dataset[key]);
        } else {
          this._createDataBind(key, this.node.dataset[key]);
        }
      }
    }

  };

  this.initAllReady = function() {
    if (!this._presenterAvalible) return false;
  };

  this.destroy = function() {
    if (!this._presenterAvalible) return false;

    // remove all computed variables and dom used to trigger computed updates
    for (var key in this._boundData) {
      if (this._boundData.hasOwnProperty(key)) {
        this._boundData[key].shadowDom.remove();

        if (!this._boundData[key].extended) {
          this.presenter.removeComputedVariable(this._boundData[key].computedId);
        }
      }
    }
  };

  this.onDataBindUpdate = function(name, callback) {
    if (!this._presenterAvalible) return false;

    // Compare old value to current value and update values to
    if (this._boundData[name] && this.presenter._isComputedProperty(this._boundData[name].computedId) && this[name] !== this.presenter._getComputedValue(this._boundData[name].computedId)) {
      this[name] = this.presenter._getComputedValue(this._boundData[name].computedId);

      // Tripper components callback if it exists
      if (this._boundData[name].callback !== null) {
        this._boundData[name].callback(this[name]);
      }
    }

    // add a callback to a property if it has been bound
    if (this._boundData.hasOwnProperty(name)) {
      this._boundData[name].callback = callback;
    }
  };

  this._createDataBind = function(key, dataString) {
    // Generate a unique ID and get the camel case property name to match data-mogo-ui variable setting.
    var computedId = 'dataBind_comp_'+ this.declaredClass +'_'+ this.id +'_data_'+ key;
    var dataName = key.split('bind')[1];
        dataName = dataName.charAt(0).toLowerCase() + dataName.substr(1);

    // Set local value.
    this[dataName] = this.presenter.getModelProperty(dataString);

    // push databind info to object
    this._boundData[dataName] = {
      extended: false,
      computedId: computedId,
      dataString: dataString,
      callback: null,
      shadowDom: $('<input id="'+computedId+'" type="hidden" data-bind="'+ computedId +'"></div>'),
    };

    // add html to page that allows computed variable to trigger
    $('body').append(this._boundData[dataName].shadowDom);

    // Add Computed Variable for callbacks.
    this.presenter.addComputedVariable(
      computedId, [dataString],

      function (value) {
        this[dataName] = value;
        if (this._boundData[dataName].callback !== null) {
          this._boundData[dataName].callback(value);
        }

        return value;
      }.bind(this)
    );
  };

  this._extendComputedDataBind = function(key, dataString) {
    // Generate a unique ID and get the camel case property name to match data-mogo-ui variable setting.
    var computedId = 'dataBind_comp_'+ this.declaredClass +'_'+ this.id +'_data_'+ key;
    var dataName = key.split('bind')[1];
        dataName = dataName.charAt(0).toLowerCase() + dataName.substr(1);

    // Set local value.
    if (this.presenter._isComputedProperty(dataString)) this[dataName] = this.presenter._getComputedValue(dataString);
    else this[dataName] = null;


    // push databind info to object
    this._boundData[dataName] = {
      extended: true,
      computedId: dataString,
      dataString: dataString,
      callback: null,
      shadowDom: $('<input id="'+computedId+'" data-name="'+ dataName +'" type="hidden" data-bind="'+ dataString +'"></div>'),
    };

    // add html to page that allows computed variable to trigger
    $('body').append(this._boundData[dataName].shadowDom);

    this._boundData[dataName].shadowDom.on('renderDOMElement', function(event) {
      // get component data bind data from shadow dom element
      var $element = $(event.target);
      var dataName = $element.attr('data-name');

      // Set the components scopes public property value
      this[dataName] = $element.val();

      // Tripper components callback if it exists
      if (this._boundData[dataName].callback !== null) {
        this._boundData[dataName].callback(this[dataName]);
      }
    }.bind(this));

  };
}
